import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from 'services/login/hooks';
import links from 'utils/links';

export function PrivateOutlet() {
  const auth = useAuth();

  if (!auth.isAuthReady) {
    return null;
  }

  if (!auth.user) {
    return <Navigate replace to={links.paths.login} />;
  }

  return <Outlet />;
}
